import React, { useState } from 'react'
import { Text, ChevronUpIcon, ChevronDownIcon } from 'vvs-uikit'
import styled from 'styled-components'
import { AutoColumn } from 'components/Layout/Column'
import { RowFixed, RowBetween } from 'components/Layout/Row'
import { DoubleCurrencyLogo } from 'components/Logo'
import { useTranslation } from 'contexts/Localization'

const FixedHeightRow = styled(RowBetween)`
  height: 24px;
`

const SwapDetail = (props) => {
  const { token0, token1, route, price, priceImpact, liquidityProviderFee } = props
  const [showMore, setShowMore] = useState(false)
  const { t } = useTranslation()
  const toggleChevron = () => {
    setShowMore(!showMore)
  }
  return (
    <AutoColumn gap="16px" marginBottom="12px">
      <FixedHeightRow onClick={toggleChevron}>
        <RowFixed>
          <DoubleCurrencyLogo currency0={token0} currency1={token1} margin size={20} />
          <Text small color="textSubtle">
            {route}
          </Text>
        </RowFixed>
        {showMore ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </FixedHeightRow>
      {showMore && (
        <AutoColumn marginBottom="12px" gap="4px">
          <FixedHeightRow>
            <Text color="textSubtle" small>
              {t('Price')}
            </Text>
            <Text>{price}</Text>
          </FixedHeightRow>
          <FixedHeightRow>
            <Text color="textSubtle" small>
              {t('Price Impact')}
            </Text>
            <Text>{priceImpact}</Text>
          </FixedHeightRow>
          <FixedHeightRow>
            <Text color="textSubtle" small>
              {t('Liquidity Provider Fee')}
            </Text>
            <Text>{liquidityProviderFee}</Text>
          </FixedHeightRow>
        </AutoColumn>
      )}
    </AutoColumn>
  )
}

export default SwapDetail
